import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

import { useUiActionRunner } from './useUiActionRunner'

export type UiStateVariables = {
  uiPage: string
  uiResource?: string
  uiResourceId?: string
  uiHasUnsavedChanges: boolean
  uiDraft?: string
}

export function useUiStateVariables(): () => Promise<UiStateVariables> {
  const { getRoutine } = useUiActionRunner()
  const { pathname } = useLocation()

  return useCallback(async () => {
    const routine = getRoutine()
    const status = routine?.status()

    const variables: UiStateVariables = {
      uiPage: pathname,
      uiResource: status?.resource,
      uiResourceId: status?.id,
      uiHasUnsavedChanges: status?.dirty ?? false,
    }

    if (status?.dirty && routine?.fetchDraft) {
      variables.uiDraft = await readDraft(routine.fetchDraft)
    }

    return variables
  }, [getRoutine, pathname])
}

async function readDraft(fetchDraft: () => Promise<unknown>): Promise<string | undefined> {
  try {
    return JSON.stringify(await fetchDraft(), null, 2)
  } catch {
    return undefined
  }
}
